class PurchaseSummary extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    this.scope = this.closest('.shopify-section, dialog');
    this.scope?.addEventListener('variant:selected', this.pending, { signal: this.controller.signal });
    this.scope?.addEventListener('variant:update', this.update, { signal: this.controller.signal });
    this.scope?.addEventListener('variant:error', this.failed, { signal: this.controller.signal });
  }

  disconnectedCallback() {
    this.controller?.abort();
  }

  pending = (event) => {
    if (event.target?.dataset.productId === this.dataset.productId) this.setAttribute('aria-busy', 'true');
  };

  failed = (event) => {
    if (event.detail?.productId === this.dataset.productId) this.removeAttribute('aria-busy');
  };

  update = (event) => {
    const data = event.detail?.data;
    if (!data || String(data.productId) !== this.dataset.productId) return;
    const updated = [...data.html.querySelectorAll('purchase-summary')].find(
      (element) => element.dataset.summaryId === this.dataset.summaryId
    );
    const state = updated?.querySelector('[data-purchase-state]');
    if (state) this.querySelector('[data-purchase-state]')?.replaceChildren(...state.cloneNode(true).childNodes);
    this.removeAttribute('aria-busy');
  };
}

if (!customElements.get('purchase-summary')) customElements.define('purchase-summary', PurchaseSummary);
